const Header = () => {
	return (
		<header className='App-header'>
			<img
				className='header-bg'
				src='/images/bg-header-desktop.svg'
				alt='header background'
			/>
		</header>
	);
};

export default Header;
